import React from "react"
import "firebase/compat/auth"
import 'firebase/compat/database'
// Firebase Analytics no se carga: su ID duplicaba las vistas en la misma propiedad de GA
// (docs/evolucion/metricas.md, 3.1). El usuario se envía al gtag del plugin desde AuthContext.
import "accionferretera-bootstrap-theme/dist/bootstrap.min.css"
import './src/css/global.css'

import { shouldUpdateScrollFn } from "acciondigital-basic-theme/src/utils/gatsbyBrowserUtils"
import { wrapPageElementQueryParams as wrapPageElementQueryProvider } from "./src/utils/wrapPageElementQueryParams"

import RootElement from "./src/components/rootElement"
//alexluong/gatsby-packages
//gatsby-plugin-use-query-params jumps to top of the page when a query param is set #33
//https://github.com/alexluong/gatsby-packages/issues/33
export const shouldUpdateScroll = shouldUpdateScrollFn

  
export const wrapPageElement = wrapPageElementQueryProvider



  export const wrapRootElement = ({ element }) => (
    <RootElement>{element}</RootElement>
  )
